var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59965 23.88L7.26965 29.91C9.81965 32.62 17.3996 30.12 23.8996 24.01C30.3996 17.9 33.3596 10.49 30.8096 7.78L25.4396 2.07C22.8496 -0.679996 15.4896 2.04 8.98965 8.15C2.48965 14.27 -0.680354 21.45 1.89965 24.2",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5195 2.16003C28.0695 4.87003 25.1095 12.28 18.6095 18.39C12.1095 24.5 4.52949 26.99 1.97949 24.29",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1598 3.48999L11.7998 23.33",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9995 16.4301V24.0801C46.9995 27.7101 39.9495 31.0001 31.2495 31.0001C28.2995 31.0001 25.5395 30.6201 23.1895 29.9801",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3301 23.4101C29.9601 23.4501 30.6001 23.4601 31.2501 23.4601C39.9501 23.4601 47.0001 20.1701 47.0001 16.5401V16.4201C47.0001 13.4301 42.3501 10.9001 35.9501 10.0601",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.48ce25a754e30471266a8bafc6e0c5fb.svg";
export { ForwardRef as ReactComponent };